import { Table } from '@material-ui/core';
import { Form } from '@unform/web';
import styled from 'styled-components';

export const Container = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  height: 100%;

  .header {
    h2 {
      font-family: Sora, sans-serif;
      font-size: 24px;
      font-weight: 600;
      color: #101d40;
    }

    & > p {
      font-family: Sora, sans-serif;
      font-size: 14px;
      font-weight: 400;
      color: #101d40;

      span {
        font-weight: 600;
      }
    }
  }
`;

export const CustomTable = styled(Table)`
  border-collapse: initial;
  font-family: Sora, sans-serif;
`;

export const TableCell = styled.tr`
  font-family: Sora, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #101d40;

  &:last-child {
    margin-left: -25px;
  }
`;

export const TableHeader = styled.thead`
  display: grid;
  column-gap: 20px;
  grid-template-rows: 1fr;
  grid-template-columns: 100px 100px 100px minmax(250px, 1fr) 50px 160px;
  padding: 16px;
  font-family: 'Sora', sans-serif;
  font-size: 10px;
  color: #acb3be;
  font-weight: 600;
  align-items: center;

  ${TableCell} {
    &:nth-child(1) {
      width: 100px;
    }

    &:nth-child(2) {
      width: 100px;
      text-align: left;
    }

    &:nth-child(3) {
      width: 100px;
      text-align: left;
    }

    &:nth-child(4) {
      width: minmax(250px, 1fr);
    }

    &:nth-child(5) {
      width: 50px;
    }

    &:nth-child(6) {
      width: 160px;
    }
  }
`;

export const ContainerGroup = styled.div`
  border: 2px solid rgb(230, 239, 251);
  border-radius: 5px;
  overflow-x: auto;
`;

export const ContainerList = styled.div`
  border: 2px solid rgb(230, 239, 251);
  border-radius: 5px;
  overflow-x: auto;

  .header {
    border-bottom: 2px solid rgb(230, 239, 251);
    overflow-x: auto;
    padding: 16px;

    h3 {
      font-family: Sora, sans-serif;
      font-size: 20px;
      font-weight: 600;
      color: #101d40;
    }
  }
`;

export const TableBody = styled.tbody`
  font-family: 'Sora', sans-serif;
  font-size: 10px;
  font-weight: 600;
  color: #101d40;
`;

export const TableRow = styled.div`
  display: grid;
  column-gap: 20px;
  grid-template-rows: 1fr;
  grid-template-columns: 100px 100px 100px minmax(250px, 1fr) 50px 160px;
  border-top: 1px solid #e6effb;
  padding: 16px;
  align-items: center;
  background-color: #ffffff;
`;

export const TableCellRow = styled.div`
  text-align: center;

  p {
    font-family: Sora, sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #101d40;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  svg:hover {
    color: #329bfc;
    cursor: pointer;
    animation: 3ms;
  }

  img {
    max-height: 32px;
  }

  &:nth-child(1) {
    width: 100px;
  }

  &:nth-child(2) {
    width: 100px;
  }

  &:nth-child(3) {
    width: 100px;
  }

  &:nth-child(4) {
    width: minmax(250px, 1fr);
  }

  &:nth-child(5) {
    width: 50px;
  }
  &:nth-child(6) {
    width: 160px;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background-color: rgba(246, 68, 68, 0.2);
    margin: none;

    svg {
      color: #f64444;
      font-size: 50px;
    }
  }

  h1 {
    color: #101d40;
    font-size: 24px;
    text-align: center;
    font-weight: 800;
    margin-top: 15px;
    font-family: 'Sora', sans-serif;
  }

  button {
    position: absolute;
    top: 10px;
    right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: rgba(215, 222, 233, 0.25);

    svg {
      color: #4f4f4f;
      font-size: 22px;
    }

    &:hover {
      background-color: rgba(215, 222, 233, 0.5);
    }
  }
`;

export const ModalForm = styled(Form)`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
